import React from "react";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";

import { templateActions } from "@pages/Applications/C&C/C&CSetup/templateStore";
import { store } from "../../store";

import { ImageDisplay } from "../../../../Common/ImageDisplay";
import { StyledButton } from "@aureskonnect/react-ui";

export function Section3Preview({ section }: any): JSX.Element {
    const { selectedLanguage } = useSnapshot(store);
    const { t } = useTranslation();

    const localData = React.useMemo(() => {
        return (
            templateActions.getNestedObject([
                "template",
                "SiteWeb",
                "LaindingPage",
                section,
            ]) || {}
        );
    }, [section]);

    const image = localData?.Image || {
        Url: "",
        Name: "",
        Type: "",
        Extenxion: "",
    };
    const buttonColor = templateActions.getNestedObject([
        "template",
        "SiteWeb",
        "Divers",
        "CouleurPrincipale",
    ]);
    return (
        <div
            style={{
                height: "80vh",
                display: "flex",
                justifyContent: "center",
                padding: "2rem",
                backgroundColor: "#f9f9f9",
                borderLeft: "1px #c6c7c9 solid",
            }}
        >
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    maxWidth: "1200px",
                    backgroundColor: "white",
                    borderRadius: "16px",
                    overflow: "hidden",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                    alignItems: "stretch",
                    height: "75%",
                    marginTop: "10%",
                }}
            >
                <div
                    style={{
                        flex: 1,
                        backgroundColor: localData.Color ?? "#f9f9f9",
                        padding: "2rem",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            backgroundColor: localData.Color ?? "#f9f9f9",
                            padding: "2rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}
                    >
                        <h2
                            style={{
                                fontSize: "1.7rem",
                                fontWeight: "bold",
                                color: "#000",
                                marginBottom: "1rem",
                            }}
                        >
                            {localData?.Title?.[selectedLanguage] || ""}
                        </h2>
                        <p
                            style={{
                                fontSize: "0.9rem",
                                color: "#333",
                                marginBottom: "1.5rem",
                            }}
                        >
                            {localData?.Description?.[selectedLanguage] || ""}
                        </p>
                        <StyledButton
                            className="mt-3 w-20 rounded"
                            style={{
                                color: "white",
                                backgroundColor: `${buttonColor}`,
                                padding: "0.6rem 1.5rem",
                                fontSize: "1rem",
                            }}
                        >
                            {t("To order")} →
                        </StyledButton>
                    </div>
                    <div
                        style={{
                            flex: 1,
                            height: "100%",
                            width: "50%",
                        }}
                    >
                        <ImageDisplay item={image} />
                    </div>
                </div>
            </div>
        </div>
    );
}
